import { format } from "date-fns";
import { useCallback, useReducer, useState } from "react";
import CaldendarTemplate from "../components/calendarTemplate/CalendarTemplate";
import PresenceSendModal from "../components/calendarTemplate/PresenceSendModal";
import SectionCard from "../components/SectionCard";

export default function Presence() {
  const [visibleMonth, setVisibleMonth] = useState(() => {
    const today = new Date();
    return {
      year: parseInt(format(today, "yyyy")),
      month: parseInt(format(today, "MM")),
    };
  });
  const [{ year, month }, dispatch] = useReducer(
    (
      _: { year?: number; month?: number },
      newState: { year: number; month: number } | undefined,
    ) => ({
      year: newState?.year,
      month: newState?.month,
    }),
    {
      year: undefined,
      month: undefined,
    },
  );
  const handlerTriggerConfirmationFormTemplate = useCallback(
    (year: number, month: number) => {
      dispatch({ year, month });
    },
    [],
  );

  const handleVisibleMonthChange = useCallback((year: number, month: number) => {
    setVisibleMonth({ year, month });
  }, []);

  const handleSendSuccess = useCallback(() => {
    const today = new Date();
    setVisibleMonth({
      year: parseInt(format(today, "yyyy")),
      month: parseInt(format(today, "MM")),
    });
  }, []);

  return (
    <SectionCard>
      <CaldendarTemplate
        year={visibleMonth.year}
        month={visibleMonth.month}
        onVisibleMonthChange={handleVisibleMonthChange}
        onCompileReport={handlerTriggerConfirmationFormTemplate}
      />
      {year && month && (
        <PresenceSendModal
          year={year}
          month={month}
          onSendSuccess={handleSendSuccess}
          dispatch={dispatch}
        ></PresenceSendModal>
      )}
    </SectionCard>
  );
}
